/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable max-classes-per-file */
import { Modal, ModalController } from '~/scripts/services/modal/modal';
import APIV5 from '~/models/api';
import template from './create-type-doc.html';

class Controller extends ModalController {
	/** @type {import('@knitiv/api-client-javascript').MinimalNode[]} */
	isa;

	/**
	 *
	 * @param {string} options
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	/* @ngInject */
	constructor(options, $uibModalInstance, $injector) {
		super(options, $uibModalInstance, $injector);

		const $translate = $injector.get('$translate');

		this.query = options;
		const documentKid = 'K_NODE;DOCUMENT';
		// @ts-ignore
		this.isa = [{
			kid: documentKid,
			name: $translate.instant('common.document'),
		}];
	}

	async create() {
		const newObject = await APIV5.instance.objectSet({
			items: [
				{
					target_objnum: 'K_NODE;_NR_001',
					OBJECT_LIST: {
						'K_NODE;_NR_001': {
							isa: 'K_NODE;SYS_CLASSE',
							REPRE_LIST: [
								{
									name: this.query,
									lang: 'K_NODE;UNIVERSEL',
									type_kid: 'K_NODE;STRING',
								},
							],
							KNDEF: [
								{
									name: 'kjson',
									value: {
										CLASS: {
											DICO: {
												'00a': {
													relation_kid: 'K_NODE;INHERITS',
													objnum2_kid: this.isa[0].kid,
													linker_kid: '0',
												},
											},
											COMMON: [
												{
													type: 'link',
													dico_id: '00a',
													card_from: 1,
													card_to: 1,
													lock: 0,
													data: '',
												},
											],
										},
									},
								},
							],
						},
					},
				},
			],
		}, { id: 'modal.create-typedoc.create' });

		const item = await APIV5.instance.objectInfo({
			// @ts-ignore
			kid: Object.keys(newObject.result)[0],
		}, {
			id: 'create-type-doc.create',
		});

		this.actions.close(item);
	}
}

class CreateTypeDoc extends Modal {
	/**
	 *
	 * @param {*} query
	 * @returns {Promise<import('@knitiv/api-client-javascript').ObjectInfoOutput>}
	 */
	open(query) {
		return super.open({
			template,
			controller: Controller,
			windowTopClass: 'filter-menu',
		}, query);
	}
}

export { CreateTypeDoc };
